import { useContext } from "react";

import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";
import WebUnAuthenticatedButton from "@components/swagmagic/profile-dropdown/unauthenticated-button/web";
import ResponsiveUnauthenticatedButton from "@components/swagmagic/profile-dropdown/unauthenticated-button/responsive";

const UnAuthenticatedButton = () => {
  const currentDeviceType = useContext(CurrentDeviceContext);
  const { isDesktopDevice } = currentDeviceType;
  return isDesktopDevice ? <WebUnAuthenticatedButton /> : <ResponsiveUnauthenticatedButton />;
};

export default UnAuthenticatedButton;
